import { Box, Button, HStack, Icon, ScrollView, Typography, Input, InputField } from "components/ui";
import { H3, Paragraph } from "components/ui/Typography";
import { X } from "lucide-react-native";
import React, { useRef, useState } from "react";
import Modal from "react-native-modal";
import { Formik } from "formik";
import * as Yup from "yup";
import FormField from "components/form/FormField";

interface AddGroupModalProps {
	isVisible: boolean;
	onClose: () => void;
	onSubmit: (groupData: { name: string }) => void;
	parentGroupName?: string;
}

const validationSchema = Yup.object().shape({
	name: Yup.string().required("Group name is required").min(3, "Group name must be at least 3 characters"),
});

export function AddGroupModal({ isVisible, onClose, onSubmit, parentGroupName }: AddGroupModalProps) {
	const scrollViewRef = useRef(null);
	const [isSubmitting, setIsSubmitting] = useState(false);

	return (
		<Modal animationIn={"fadeIn"} animationOut={"fadeOut"} scrollOffset={1} onBackdropPress={onClose} isVisible={isVisible}>
			<Box bg="$basicwhite" overflow="hidden" borderRadius={12} height={300}>
				<HStack alignItems="center" justifyContent="space-between" bg="$lighttealxlight" paddingHorizontal={28} paddingVertical={20}>
					<H3>Add group{parentGroupName ? ` to ${parentGroupName}` : ""}</H3>
					<Box>
						<Button onPress={onClose} gap={6}>
							<Icon as={X} />
							<Typography>Close</Typography>
						</Button>
					</Box>
				</HStack>

				<ScrollView sx={{ width: "100%", height: 400, padding: 28 }} ref={scrollViewRef}>
					<Formik
						initialValues={{
							name: "",
						}}
						validationSchema={validationSchema}
						onSubmit={async (values, { resetForm }) => {
							setIsSubmitting(true);
							await onSubmit(values);
							resetForm();
							setIsSubmitting(false);
						}}
					>
						{(formik) => (
							<Box gap={20}>
								<Box>
									<FormField name="name" label="Group Name" placeholder="Enter group name" formik={formik} autoFocus onSubmitEditing={() => formik.handleSubmit()} />
								</Box>
								<Button width={120} variant="secondary" onPress={() => formik.handleSubmit()} disabled={formik.isSubmitting || isSubmitting}>
									{formik.isSubmitting ? <Typography weight="bold">Saving...</Typography> : <Typography weight="bold">Save</Typography>}
								</Button>
							</Box>
						)}
					</Formik>
				</ScrollView>
			</Box>
		</Modal>
	);
}
